var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1483_13161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9085 9.35718H10.0914C9.69909 9.35718 9.31062 9.43448 8.94819 9.58468C8.58576 9.73487 8.25648 9.95501 7.97916 10.2325C7.70184 10.51 7.48192 10.8394 7.33197 11.202C7.18201 11.5645 7.10497 11.953 7.10523 12.3453V17.6545C7.10497 18.0469 7.18201 18.4354 7.33197 18.7979C7.48192 19.1604 7.70184 19.4899 7.97916 19.7674C8.25648 20.0449 8.58576 20.265 8.94819 20.4152C9.31062 20.5654 9.69909 20.6427 10.0914 20.6427H19.9085C20.3008 20.6427 20.6893 20.5654 21.0517 20.4152C21.4142 20.265 21.7434 20.0449 22.0208 19.7674C22.2981 19.4899 22.518 19.1604 22.668 18.7979C22.8179 18.4354 22.895 18.0469 22.8947 17.6545V12.3453C22.895 11.953 22.8179 11.5645 22.668 11.202C22.518 10.8394 22.2981 10.51 22.0208 10.2325C21.7434 9.95501 21.4142 9.73487 21.0517 9.58468C20.6893 9.43448 20.3008 9.35718 19.9085 9.35718ZM12.9197 17.4197V12.5802L17.0802 14.9999L12.9197 17.4197Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1483_13161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaYoutube);
export default __webpack_public_path__ + "static/media/FaYoutube.17b67f899dc49bcb64b51c5a764f22aa.svg";
export { ForwardRef as ReactComponent };